import NumerousLogo from "@/components/logo/NumerousLogo";
import FullScreenLoading from "@/components/ui/fullScreenLoading";

export function OrganizationInvitationsLoading() {
  return (
    <div className="w-full flex flex-col gap-y-2 justify-center items-center">
      <NumerousLogo type="fullLogo" size="sm" className="absolute top-4" />
      <FullScreenLoading
        message="Loading pending invitations"
        className="dark:bg-black"
      />
    </div>
  );
}
